export default {
    bySection(section) {
        return this.transformer.one(
            this.try(
                this.baseQuery().where('section', section).first()
            )
        )
    }
}
